export enum PlumbEndpointType {
    Rectangle = 'Rectangle',
    Dot = 'Dot',
    Blank = 'Blank',
    Image = 'Image',
}
